// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"29":"20b45a3104362764","377":"d745f7693906c341","822":"3b1f677f94f5d61d"}[chunkId] + ".css";
};